
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')
      .addEventListener('click', this.close.bind(this));

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');

    if (inner.classList.contains('is-empty')) {
      inner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // Re-bind overlay click
    this.querySelector('#CartDrawer-Overlay')
      .addEventListener('click', this.close.bind(this));

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

/* ===========================
   CART ITEMS EXTENSION
=========================== */

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ===========================
   🔥 PROGRESS BAR LOGIC
=========================== */

/* ===========================
   PROGRESS BAR UPDATE
=========================== */

function updateCartProgressBar(count) {
  const container = document.querySelector('.master-conteiner_for_progress-bar');
  if (!container) return;

  const pills = container.querySelectorAll('.pill');
  const msg = container.querySelector('.progress-bar_extra-msg span');
  const bar = container.querySelector('.progress-bar-v2');

  pills.forEach(p => p.classList.remove('active'));

  if (count >= 1) pills[0]?.classList.add('active');
  if (count >= 2) pills[1]?.classList.add('active');
  if (count >= 3) pills[2]?.classList.add('active');
  if (count >= 4) pills[3]?.classList.add('active');
  if (count >= 5) pills[4]?.classList.add('active');

  let progress = [0, 20, 40, 60, 80, 100][Math.min(count, 5)];
  if (bar) bar.style.setProperty('--progress', progress + '%');

  let text = '';
  if (count <= 2) {
    let remain = 3 - count;
    text = `Just ${remain} more item${remain > 1 ? 's' : ''} for <strong>10% OFF</strong>`;
  } else if (count === 3) {
    text = `Just 1 more item for <strong>15% OFF</strong>`;
  } else if (count === 4) {
    text = `Just 1 more item for <strong>20% OFF</strong>`;
  } else {
    text = `🎉 You unlocked <strong>20% OFF</strong>`;
  }

  if (msg) msg.innerHTML = text;
}

/* ===========================
   SAFE CART SYNC
=========================== */

function syncCartProgress() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartProgressBar(cart.item_count);
    });
}

/* ===========================
   🔥 RE-ATTACH OBSERVER AFTER EVERY CHANGE
=========================== */

function observeCartDrawer() {
  const drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    syncCartProgress();
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true
  });
}

/* ===========================
   🔥 AUTO INIT (RELIABLE)
=========================== */

function initProgressSystem() {
  syncCartProgress();
  observeCartDrawer();
}

/* RUN ON LOAD */
document.addEventListener('DOMContentLoaded', initProgressSystem);

/* 🔥 ALSO RUN WHEN DRAWER OPENS (IMPORTANT) */
document.addEventListener('click', function(e) {
  if (e.target.closest('#cart-icon-bubble')) {
    setTimeout(() => {
      initProgressSystem();
    }, 200);
  }
});